<template>
  <div>
    <Header/>
    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">รายงานสั่งซื้อสินค้า</h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <a href="#">รายงาน</a>
                </li>
                <li class="breadcrumb-item active">รายงานสั่งซื้อสินค้า</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- Content body. -->
      <section class="content">
        <div class="container-fluid">
          <div class="card">
            <div class="card-header d-flex">
              <div class="col-10">
                <form class="d-flex" @submit.prevent="search()">
                  <div class="form-group p-2">
                    <div class="input-group">
                      <label class="text-10">วันที่เริ่มต้น: </label>
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fas fa-calendar"></i>
                        </span>
                      </div>
                      <input type="date" class="form-control form-control-sm float-right" v-model="form.date_start" required title="กรุณาป้อนวันที่เริ่มต้น">
                    </div>
                  </div>
                  <div class="form-group p-2">
                    <div class="input-group">
                      <label class="text-10">วันที่สิ้นสุด: </label>
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="fas fa-calendar"></i>
                        </span>
                      </div>
                      <input type="date" class="form-control form-control-sm float-right" v-model="form.date_end" required title="กรุณาป้อนวันที่สิ้นสุด">
                    </div>
                  </div>
                  <div class="form-group p-2">
                    <button type="submit" class="btn btn-primary btn-sm">ค้นหา <i class="fas fa-search"></i></button>
                  </div>
                  <div class="form-group p-2">
                    <button class="btn btn-danger btn-sm" v-print="'#printReport'">Print <i class="fas fa-print"></i></button>
                  </div>
                </form>
              </div>
            </div>
            <div class="card-body" id="printReport">
              <h5 class="text-center">รายงานสั่งซื้อสินค้า</h5>
              <div class="d-flex justify-content-between">
                <div>
                  <span class="text-10 p-2"><i class="fas fa-calendar"></i> วันที่เริ่มต้น: {{(form.date_start !='') ? moment(form.date_start).locale('th').format('llll') : moment().locale('th').format('llll')}}</span>
                  <span class="text-10 p-2"><i class="fas fa-calendar"></i> วันที่สิ้นสุด: {{(form.date_end !='') ? moment(form.date_end).locale('th').format('llll') : moment().locale('th').format('llll')}}</span>
                </div>
                <div>
                  <span class="text-10"><i class="fas fa-calendar"></i> วันที่ออกรายงาน: {{moment().locale('th').format('llll')}}</span>
                </div>
              </div>
              <table class="table table-bordered">
                  <thead>
                      <tr class="text-center">
                          <td>ลำดับ</td>
                          <td>เลขที่สั่งซื้อ</td>
                          <td>ชื่อลูกค้า</td>
                          <td>ชื่อ(ชื่อร้าน)</td>
                          <td>จำนวนรายการ</td>
                          <td class="text-right">จำนวนเงิน</td>
                          <td>วันที่สั่งซื้อ</td>
                      </tr>
                  </thead>
                  <tbody v-if="reportOrder">
                      <tr v-for="(report,index) in reportOrder" :key="report.index" class="text-center">
                          <td>{{++index}}</td>
                          <td>{{report.order_id}}</td>
                          <td>{{report.cus_name}} {{report.cus_lastname}}</td>
                          <td>{{report.order_name}}</td>
                          <td>{{report.list_product}}</td>
                          <td class="text-right">{{report.total_price | numberFormat}} BTH</td>
                          <td>{{report.created_at}}</td>
                      </tr>
                      <tr>
                        <td colspan="6" class="text-right">ยอดเงินทั้งหมด</td>
                        <td class="text-right">{{total_money | numberFormat}} BTH</td>
                      </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                        <td colspan="7" class="text-danger text-center">ไม่พบข้อมูล</td>
                      </tr>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import Header from "../components/HeaderBack";
export default {
  components: {
    Header
  },
  data(){
      return {
          reportOrder:{},
          form: new Form({
            date_start: '',
            date_end: ''
          }),
          moment: moment,
          total_money:''
      }
  },
  beforeCreate() {
    this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/checkBeforeLogin', {
        keyid: this.$session.get('keyid'),
        keyserial: this.$session.get('keyserial'),
        keytoken: this.$session.get('keytoken'),
      })
      .then((response) => {
        if(response.data.checkLogin === 0){
          this.pageShow = false
          window.location.href = '/pageLogin'
        }else{
          this.pageShow = true
        }
      })
  },
  methods: {
    search(){
        this.form.post('http://pgm01.toonjob.com/2019/BannKlong/project/searchReportOrderDate')
        .then((response) => {
          this.reportOrder = response.data.data
          this.total_money = response.data.total_money[0].total_money
        })
    },
    reportDataOrder(){
        this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/reportDataOrder')
        .then((response) => {
            this.reportOrder = response.data.data
            this.total_money = response.data.total_money[0].total_money
        })
    }
  },
  created() {
      this.$Progress.start()
      this.reportDataOrder()
      this.$Progress.finish()
  }
};
</script>


// WEBPACK FOOTER //
// src/backEnd/ReportOrders.vue